import createAttributeApi from "../../processes/api/attributes/createAttributeApi";
import {
  addOrUpdateAttribute,
  addOrUpdateItemsAttribute,
  changeShowModal,
} from "../../redux/actions";
import { attributesNamesT } from "../../redux/reducers/types";
import { requestT } from "../../utils/constants";
function cloneAndAppendTo(str: any, count: number) {
  // Создаем копию строки
  const clone = str;

  // Добавляем копию строки в конец
  const result = clone + ` (${count + 1})`;

  return result;
}
type duplicateItemsAttributeEventT = {
  name: string;
  nameAttr: attributesNamesT;
  itemId: number;
  attrId: number;
  count: number;
  dispatch: any;
  otherValues?: any;
  otherParams?: any;
  url: string;
  request: requestT;
  typeSend?: "json" | "formData";
};
export const duplicateItemsAttributeEvent = async ({
  nameAttr,
  attrId,
  dispatch,
  itemId,
  url,
  request,
}: duplicateItemsAttributeEventT) => {
  dispatch(changeShowModal({ nameModal: "loader", stateModal: true }));

  const newAttr = await createAttributeApi({
    values: {},
    urlParam: `duplicate/${itemId}`,
    typeSend: "json",
    url,
    request,
  });
  if (newAttr) {
    dispatch(
      addOrUpdateItemsAttribute({
        attrId: attrId,
        itemId: newAttr.id,
        attrName: nameAttr,
        attrValue: {
          ...newAttr,
          cache: false,
        },
        type: "add",
      })
    );
    dispatch(changeShowModal({ nameModal: "loader", stateModal: false }));
  }
};
